
import request from '@/request'

//获取列表
export function getList(data){
    return request({
        url:'script/dictionary_list',
        method:'post',
        data
    })
}

//获取列表(新)
export function type_dictionary(data){
    return request({
        url:'script/type_dictionary?'+data,
        method:'get',
    })
}



//新增
export function dictionary_add(data){
    return request({
        url:'script/dictionary_add',
        method:'post',
        data
    })
}

//修改
export function dictionary_edit(data){
    return request({
        url:'script/dictionary_edit',
        method:'post',
        data
    })
}

//删除
export function dictionary_del(data){
    return request({
        url:'script/dictionary_del',
        method:'post',
        data
    })
}

